// eslint-disable-next-line no-extend-native
Array.prototype.unique = function (remove = true) {
  const duplicates = []
  const arr = this.sort() // input must be sorted for this to work
  for (let i = arr.length; i--;) {
    if (arr[i] === arr[i - 1]) {
      (remove) ? arr.splice(i, 1) : duplicates.push(arr[i])
    }
  }
  return (remove) ? arr : duplicates
}

// eslint-disable-next-line no-extend-native
Array.prototype.duplicates = function () {
  return this.unique(false)
}

// taken from https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
// eslint-disable-next-line no-extend-native
Array.prototype.shuffle = function () {
  let currentIndex = this.length
  let temporaryValue
  let randomIndex

  // While there remain elements to shuffle...
  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1
    // And swap it with the current element.
    temporaryValue = this[currentIndex]
    this[currentIndex] = this[randomIndex]
    this[randomIndex] = temporaryValue
  }
  return this
}
